import { render } from "./DashboardDualChart.vue?vue&type=template&id=650f3436"
import script from "./DashboardDualChart.vue?vue&type=script&lang=js"
export * from "./DashboardDualChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/DashboardDualChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "650f3436"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('650f3436', __exports__)) {
    api.reload('650f3436', __exports__)
  }
  
  module.hot.accept("./DashboardDualChart.vue?vue&type=template&id=650f3436", () => {
    api.rerender('650f3436', render)
  })

}


export default __exports__